import {DeliverabilityStatusBadge} from '../../shared/deliverability-status-badge';

import {useGetContactDeliverabilityStatuses} from '../graphql/hooks/use-get-contact-deliverability-statuses';

type Props = {
    contactId: string;
};

export function ContactDeliverablityStatusBadges(props: Props) {
    const {emailDeliverabilityStatus, smsDeliverabilityStatus} =
        useGetContactDeliverabilityStatuses(props.contactId);

    const showSmsBadge =
        smsDeliverabilityStatus && smsDeliverabilityStatus.status !== 'DELIVERABLE';
    const showEmailBadge =
        emailDeliverabilityStatus && emailDeliverabilityStatus.status !== 'DELIVERABLE';

    const iconOnly = Boolean(showEmailBadge && showSmsBadge);

    return (
        <div className='flex gap-8'>
            {showEmailBadge && (
                <DeliverabilityStatusBadge
                    deliverabilityStatus={emailDeliverabilityStatus}
                    iconOnly={iconOnly}
                />
            )}
            {showSmsBadge && (
                <DeliverabilityStatusBadge
                    deliverabilityStatus={smsDeliverabilityStatus}
                    iconOnly={iconOnly}
                />
            )}
        </div>
    );
}
